import AuthLayout from "../components/AuthLayout";

export default function PasswordChanged({ onLoginNow }) {
  return (
    <AuthLayout>

      <main className="flex-1 flex items-center justify-center px-4 py-8">
        <div className="w-full max-w-md text-center">
          <div className="mb-8">
            <div className="inline-block mb-6">
              <svg className="w-32 h-32" viewBox="0 0 200 150" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M80 90 L90 80 L100 90" stroke="black" strokeWidth="3" fill="none"/>
                <path d="M90 80 L90 110" stroke="black" strokeWidth="3"/>
                <circle cx="100" cy="50" r="5" fill="black"/>
                <path d="M100 55 L95 110" stroke="black" strokeWidth="2" fill="none"/>
                <circle cx="95" cy="110" r="3" fill="black"/>
              </svg>
            </div>
            <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
              Password changed!
            </h1>
            <p className="text-gray-500">
              You've Successfully Completed Your Password Reset!
            </p>
          </div>

          <button
            onClick={onLoginNow}
            className="w-full bg-[#06402B] text-white py-3 rounded-full font-medium hover:bg-green-900 transition-colors"
          >
            Log In Now
          </button>
        </div>
      </main>

      
</AuthLayout>
  );
};
